import * as types from '../../lib/actionTypes.es6';

export function getAllWebhookSubscriptionsRequest(params = {}) {
  return {
    type: types.VIEW_ALL_WEBHOOK_SUBSCRIPTIONS_REQUEST,
    payload: params,
  };
}

export function getAllWebhookSubscriptionsSuccess(subscriptions) {
  return {
    type: types.VIEW_ALL_WEBHOOK_SUBSCRIPTIONS_SUCCESS,
    payload: subscriptions,
  };
}

export function getAllWebhookSubscriptionsFail(error) {
  return {
    type: types.VIEW_ALL_WEBHOOK_SUBSCRIPTIONS_FAILURE,
    payload: error,
  };
}

export function createWebhookSubscriptionRequest(subscription) {
  return {
    type: types.CREATE_WEBHOOK_SUBSCRIPTION_REQUEST,
    payload: subscription,
  };
}

export function createWebhookSubscriptionSuccess(subscription) {
  return {
    type: types.CREATE_WEBHOOK_SUBSCRIPTION_SUCCESS,
    payload: subscription,
  };
}

export function createWebhookSubscriptionFail(error) {
  return {
    type: types.CREATE_WEBHOOK_SUBSCRIPTION_FAILURE,
    payload: error,
  };
}

export function resetCreateWebhookSuccess() {
  return {
    type: types.RESET_CREATE_WEBHOOK_SUCCESS,
  };
}

export function resetCreateWebhookError() {
  return {
    type: types.RESET_CREATE_WEBHOOK_ERROR,
  };
}

export function editWebhookSubscriptionRequest(subscription) {
  return {
    type: types.EDIT_WEBHOOK_SUBSCRIPTION_REQUEST,
    payload: subscription,
  };
}

export function editWebhookSubscriptionSuccess(subscription) {
  return {
    type: types.EDIT_WEBHOOK_SUBSCRIPTION_SUCCESS,
    payload: subscription,
  };
}

export function editWebhookSubscriptionFail(error) {
  return {
    type: types.EDIT_WEBHOOK_SUBSCRIPTION_FAILURE,
    payload: error,
  };
}

export function resetEditWebhookSuccess() {
  return {
    type: types.RESET_EDIT_WEBHOOK_SUCCESS,
  };
}

export function resetEditWebhookError() {
  return {
    type: types.RESET_EDIT_WEBHOOK_ERROR,
  };
}

export function deleteWebhookSubscriptionRequest(guid) {
  return {
    type: types.DELETE_WEBHOOK_SUBSCRIPTION_REQUEST,
    payload: guid,
  };
}

export function deleteWebhookSubscriptionSuccess(subscription) {
  return {
    type: types.DELETE_WEBHOOK_SUBSCRIPTION_SUCCESS,
    payload: subscription,
  };
}

export function deleteWebhookSubscriptionFail(error) {
  return {
    type: types.DELETE_WEBHOOK_SUBSCRIPTION_FAILURE,
    payload: error,
  };
}

export function saveWebhookSubscriptionAuthRequest(guid, authConfig) {
  return {
    type: types.SAVE_WEBHOOK_SUBSCRIPTION_AUTH_REQUEST,
    payload: { guid, authConfig },
  };
}

export function saveWebhookSubscriptionAuthSuccess(subscription) {
  return {
    type: types.SAVE_WEBHOOK_SUBSCRIPTION_AUTH_SUCCESS,
    payload: subscription,
  };
}

export function saveWebhookSubscriptionAuthFail(error) {
  return {
    type: types.SAVE_WEBHOOK_SUBSCRIPTION_AUTH_FAILURE,
    payload: error,
  };
}

export function deleteWebhookSubscriptionAuthRequest(guid) {
  return {
    type: types.DELETE_WEBHOOK_SUBSCRIPTION_AUTH_REQUEST,
    payload: guid,
  };
}

export function deleteWebhookSubscriptionAuthSuccess(subscription) {
  return {
    type: types.DELETE_WEBHOOK_SUBSCRIPTION_AUTH_SUCCESS,
    payload: subscription,
  };
}

export function deleteWebhookSubscriptionAuthFail(error) {
  return {
    type: types.DELETE_WEBHOOK_SUBSCRIPTION_AUTH_FAILURE,
    payload: error,
  };
}

export function resetAuthWebhookSuccess() {
  return {
    type: types.RESET_AUTH_WEBHOOK_SUCCESS,
  };
}

export function resetAuthWebhookError() {
  return {
    type: types.RESET_AUTH_WEBHOOK_ERROR,
  };
}
